import { Card, CardContent, List, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useAuth } from '../../hooks/useAuth'
import useIsVisible from '../../hooks/useIsVisible'
import { useScheduledActivityMessagesContext } from '../../hooks/useScheduledActivityMessagesContext'
import { ScheduledActivity } from '../../models/Activity'
import { ScheduledActivityMessage } from '../../models/ScheduledActivityMessage'
import useStyles from "../../styles/useStyles"
import { WEBIP_CURRENT_ID, isNonVolunteerEvent } from '../../util/scheduledActivityUtils'
import ScheduledActivityMessageDetail from './ScheduledActivityMessageDetail'
import ScheduledActivityMessageForm from './ScheduledActivityMessageForm'

interface Props {
  sa: ScheduledActivity | null
  disableMessage?: boolean,
  allowTeamMessage?: boolean,
  orgUnitId?: string
}

export default function ScheduledActivityMessages({ sa, disableMessage, orgUnitId }: Props) {
  const styles = useStyles();
  const { isWizard } = useAuth()

  const {
    scheduledActivityMessages,
    scheduledActivityTeamMessages,
    createScheduledActivityMessage,
    pauseMessagesSubscription,
    resumeMessagesSubscription,
  } = useScheduledActivityMessagesContext()

  const handleVisibilityChange = (visible: boolean) => {
    if (visible) {
      resumeMessagesSubscription()
    } else {
      pauseMessagesSubscription()
    }
  }

  useIsVisible(handleVisibilityChange)

  if (!sa) return null

  const messageFormAndDetails = (
    messages: ScheduledActivityMessage[] | null,
    enableForm: boolean,
    disableReply: boolean,
    showCta: boolean,
    ouId?: string
  ) => {
    const noAnnouncements = (isNonVolunteerEvent(sa) || sa.id === WEBIP_CURRENT_ID) &&
      (!messages || messages.length === 0) && !isWizard()
    return (
      <Box>
        <Card sx={{ boxShadow: "none" }}>
          <CardContent className={styles.cardContentContrast}>
            {enableForm &&
              <ScheduledActivityMessageForm
                label="New Message"
                autoFocus={false}
                createMessage={createScheduledActivityMessage}
                orgUnitId={ouId}
              />
            }
            <List>
              {noAnnouncements && showCta ?
                <Typography>
                  Announcements will be posted here.
                </Typography>
              :
                <>
                  {messages?.map((message) => (
                    <ScheduledActivityMessageDetail
                      message={message}
                      key={message.id}
                      disableReply={disableReply}
                    />
                  ))}
                </>
              }
            </List>
          </CardContent>
        </Card>
      </Box>
    )
  }

  if (orgUnitId) {
    return (
      <>
        {messageFormAndDetails(scheduledActivityMessages, !disableMessage, true, true, undefined)}
        <Typography variant='h4'>
          Team message board
        </Typography>
        {messageFormAndDetails(scheduledActivityTeamMessages, true, true, false, orgUnitId)}
      </>
    )
  }

  return (
    <>
      {messageFormAndDetails(scheduledActivityMessages, !disableMessage, !!disableMessage, true, orgUnitId)}
    </>
  )
}
